import WalletTransactionList from './wallet-transaction.list';

export default {
  list: WalletTransactionList,
};
